import {cs}  from "@Common/react/chain-services";
import {snv} from "@Common/utils/arr-path";

import {BulkMailPermitBase} from "@Xpresso/routes/common/heavy/bulk-mail-permit/bulk-mail-permit-base";
import {chain} from "@Common/utils/fs";

export const ScBulkMailPermitLogic = ({templateOptions, initEnrollment, agentId, next: rootNext}) => cs(

    ["base", (_, next) => BulkMailPermitBase({
        agentId,
        templateOptions,
        initSelected: (
            initEnrollment?.distribution_options?.mailing?.unaddressed_copies?.bulk_mail_permit ??
            initEnrollment?.distribution_options?.shipping?.addressed_copies?.bulk_mail_permit ??
            false
        ),
        next,
    })],

    ({base}) => rootNext(!base.allowed ? null : {
        ui: {
            selected: base.selected,
            render: base.render,
        },
        enrollmentEditor: {
            $name: "bulk mail permit",
            prepareSave: (enrollment) => ({
                newValue: chain(
                    enrollment,
                    (_) => snv(_, ["distribution_options", "mailing", "unaddressed_copies", "bulk_mail_permit"], base.selected.value),
                    (_) => snv(_, ["distribution_options", "shipping", "addressed_copies", "bulk_mail_permit"], base.selected.value),
                ),
                onSaved: base.saveSelected,
            }),

            changed: base.changed,

            valid: !base.selected.value || base.valid,
            errorsHandling: {
                highlightErrors: () => {
                    base.highlightErrors();
                },
            },
        },
    }),
);
